// Invoice / receipt number formatting.
//
// The raw sequential number lives in `sales.receipt_number` and is assigned
// atomically per business by a DB trigger (see pointbunny-admin-updates.md), so
// it is gapless and race-safe. It starts at 1001 for every business.
//
// The DISPLAYED form is `INV-<year>-<number>`, where the year comes from the
// sale's own date (not "now"), so a historical sale always shows the year it was
// rung up in. The sequence itself is continuous across years - the year is a
// label only, it never resets the count.

export function formatInvoiceNumber(receiptNumber, date) {
  if (receiptNumber == null) return null;
  const d = date ? new Date(date) : new Date();
  const year = isNaN(d.getTime()) ? new Date().getFullYear() : d.getFullYear();
  return `INV-${year}-${receiptNumber}`;
}

// The label printed before the number (e.g. "Invoice No.") - localized to the
// term each market legally expects. The DISPLAYED label changes only; the stored
// number format never does. Default (incl. the US, our primary market) is the
// universal "Invoice No.".
//   - PH    : BIR calls a goods receipt a "Sales Invoice".
//   - AU/NZ : GST law requires the wording "Tax Invoice".
const SALES_INVOICE_COUNTRIES = new Set(['PH']);
const TAX_INVOICE_COUNTRIES = new Set(['AU', 'NZ']);

// Country comes from the explicit arg when available, else the value stashed in
// localStorage at login (so popup windows can localize too).
const _country = (country) =>
  (country ?? (typeof localStorage !== 'undefined' ? localStorage.getItem('pointbunny_business_country') : '') ?? '').toUpperCase();

export function invoiceLabel(country) {
  const c = _country(country);
  if (SALES_INVOICE_COUNTRIES.has(c)) return 'Sales Invoice No.';
  if (TAX_INVOICE_COUNTRIES.has(c)) return 'Tax Invoice No.';
  return 'Invoice No.';
}
